import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { DateTime } from 'luxon'

import { SLICE_KEYS } from '../SliceKeys'
import { ChangeInstalmentMonthSelectionProps, IInstalmentsMonthsState } from './InstalmentsMonthsSliceModels'
import { cleanInstalmentsMonthErrorOnSelect, setInstalmentsMonthErrorOnUnselect } from './instalmentsMonthHelperFunctions'
import { PaymentSchedule } from 'models/prepare.offert.model.dto'

export const MINIMAL_NUMBER_OF_SELECTED_MONTHS = 2
export const MINIMAL_GAP_BETWEEN_SELECTED_MONTHS = 2
export const initialInstalmentsMonthsState: IInstalmentsMonthsState[] = []


export const instalmentsMonthsSlice = createSlice({
   name: SLICE_KEYS.INSTALMENTS_MONTHS_SLICE,
   initialState: initialInstalmentsMonthsState,
   reducers: {
      iniciateInstalmentsMonthTable: (state, action: PayloadAction<PaymentSchedule[]>) => {
         const paymentSchedule = action.payload
         let dateTimeObject = undefined // Początkowo undefined. Na późniejszym etapie przybiera wartość ostatniego miesiącaz tablicy paymentSchedule z Backendu.
        

         if(state.length === 0){          
            for (let i = 0; i < 12; i++) {
               if(paymentSchedule[i] !== undefined){ // Tyle miesięcy ile backend przekazał, tyle wykorzystujemy
                  const paymentDateDateTimeObject = DateTime.fromISO(new Date(paymentSchedule[i].paymentDate).toISOString())

                  state.push({
                     installmentNumber: paymentSchedule[i].installmentNumber,
                     label: paymentDateDateTimeObject.monthShort,
                     dateISO: paymentDateDateTimeObject.toISODate(),
                     isSelected: paymentSchedule[i].isSelected,
                     hasError: false
                  })

               }
               else { //Dla miesięcy których backend nie przekazał - Front dokonuje dalszej kalkulacji, tak aby zawsze  było 12 miesięcy
                  if(dateTimeObject === undefined) {
                     dateTimeObject = DateTime.fromISO(new Date(paymentSchedule.at(-1)?.paymentDate ?? "").toISOString()).plus({ months: 1 })
                  }

                  state.push({
                     installmentNumber: i + 1, // Liczymy od 0, więc trzeba dodać 1
                     label: dateTimeObject.monthShort,
                     dateISO: dateTimeObject.toISODate(),
                     isSelected: false, //Miesiące dodane przez Front, nie są domyślnie zaznaczone
                     hasError: false
                  })
                  
                  dateTimeObject = dateTimeObject.plus({ months: 1 })
               }
            }
         }
      },
      changeInstalmentMonthSelection: (state, action: PayloadAction<ChangeInstalmentMonthSelectionProps>) => {
         // Miesiąc z listy dla którego obecnie dokonujemy zmian. `monthIndex` musi być poprawnym indeksem miesiąca ze state'u.
         const currentMonthObjectToChange = state.find((currentState: IInstalmentsMonthsState) => currentState.installmentNumber === action.payload.monthIndex) as IInstalmentsMonthsState

         if(action.payload.newSelectionValue === true) {
            currentMonthObjectToChange.isSelected = true   // Gdy użytkownik ZAZNACZA dany miesiąc, nie musimy dokonywać dodatkowych sprawdzeń. Zaznaczyć może zawsze 
            currentMonthObjectToChange.hasError = false

            cleanInstalmentsMonthErrorOnSelect(state)
         }
         else {
            const STARTING_MONTH_INDEX = 1 // Index startowego miesiąca - w backendzie zawsze będzie to 1

            // Gdy użytkownik ODZNACZA dany miesiąc, musimy upewnić się czy może to zrobić. 
            // WARUNEK 1: Pierwszy miesiąc z tablicy ZAWSZE MUSI BYĆ ZAZNACZONY
            // WARUNEK 2: CO NAJMNIEJ 2 MIESIĄCE zawsze muszą być ZAZNACZONE   
            const currentSelectedMonthsNumber = state.filter((currentState: IInstalmentsMonthsState) => currentState.isSelected).length

            if(action.payload.monthIndex !== STARTING_MONTH_INDEX && currentSelectedMonthsNumber > MINIMAL_NUMBER_OF_SELECTED_MONTHS){
               currentMonthObjectToChange.isSelected = action.payload.newSelectionValue
            }

            setInstalmentsMonthErrorOnUnselect(state)
         }
      },
      quickMonthsChoiceSetActive: (state, action: PayloadAction<number>) => {
         const newState = state

         for (let index = 0; index < newState.length; index++) {
            if( index < action.payload){
               newState[index].isSelected = true
               newState[index].hasError = false // W przypadku predefiniowanych przycisków, mamy pewność że miesiące są prawidłowo zaznaczone
            }
            else {
               newState[index].isSelected = false
               newState[index].hasError = false // W przypadku predefiniowanych przycisków, mamy pewność że miesiące są prawidłowo zaznaczone
            }
         }

         state = newState
      }
   }  
 })
 
 // Action creators are generated for each case reducer function
 export const { iniciateInstalmentsMonthTable, changeInstalmentMonthSelection, quickMonthsChoiceSetActive } = instalmentsMonthsSlice.actions
 
 export default instalmentsMonthsSlice.reducer